export default __webpack_public_path__ + "static/media/premiumplus.b8d8a6e3.png";